import React from 'react';

/**
 * Profile info display component
 * Shows username, email, age, and location (non-editable info)
 */
const ProfileInfo = ({ user }) => {
  return (
    <div className="space-y-4">
      {/* Username */}
      <div className="text-center">
        <p className="text-sm">
          <span className="font-semibold text-gray-700">Swyper ID:</span>{' '}
          <span className="text-gray-500">@{user.username}</span>
        </p>
      </div>

      {/* Email */}
      <div className="flex items-center justify-center gap-2 text-gray-600">
        <span className="text-sm">{user.email}</span>
      </div>

      {/* Age and Location */}
      <div className="flex items-center justify-center gap-4 text-gray-600">
        {user.age && (
          <span className="text-sm">{user.age} years old</span>
        )}
        {user.location && (
          <span className="text-sm">📍 {user.location}</span>
        )}
      </div>
    </div>
  );
};

export default ProfileInfo;
